export const agents = {
  title: "Agentes",
  subtitle: "Crea y administra agentes para automatizar tus tareas",
  newAgent: "Nuevo Agente",
  noAgents: "No se encontraron agentes",
  edit: "Editar",
  delete: "Eliminar",
  name: "Nombre",
  description: "Descripción",
  systemPrompt: "Prompt del Sistema",
  greeting: "Mensaje de bienvenida",
  created: "Creado el {{date}}",
  profilePicture: "URL de la imagen de perfil",
  temperature: "Temperatura",
  model: "Modelo",
  tools: "Herramientas",
  create: "Crear Agente",
  table: {
    title: "Nombre",
    description: "Descripción",
    tools: "Herramientas",
    actions: "Acciones",
    model: "Modelo",
  },
  actions: {
    edit: "Editar",
    delete: "Eliminar",
    copyId: "Copiar ID",
    embed: "Insertar", //  "Embed" is often translated as "Insertar" or "Incrustar" in a web context.
    embedCodeCopied: "Código de inserción copiado al portapapeles",
    embedCodeCopiedDescription: "Podés pegarlo en cualquier lugar", // Using "Podés" (vos form)
  },
  character: "Personaje",
  update: "Actualizar",
  usageMode: "Modo de Uso",
  anonymous: "Anónimo",
  authenticated: "Autenticado",
};
